import { render, staticRenderFns } from "./SearchChat.vue?vue&type=template&id=f6a78cce&scoped=true"
import script from "./SearchChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchChat.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchChat.vue?vue&type=style&index=0&id=f6a78cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a78cce",
  null
  
)

export default component.exports